var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapGeoSi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "2je8noc6ya",
    width: "135.7%",
    height: "135.7%",
    x: "-17.9%",
    y: "-17.9%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "ihl5f4l3kc"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.431372 0 0 0 0 0.384314 0 0 0 0 0.349020 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "489gcysnvb",
    cx: 21,
    cy: 21,
    r: 21
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#2je8noc6ya)",
    xlinkHref: "#489gcysnvb"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#489gcysnvb"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "nonzero",
    filter: "url(#ihl5f4l3kc)",
    transform: "translate(9 9)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 11h-2.56c-.462-4.164-3.775-7.478-7.94-7.941V.5c0-.276-.224-.5-.5-.5h-1c-.276 0-.5.224-.5.5v2.559C6.835 3.522 3.522 6.836 3.059 11H.5c-.276 0-.5.224-.5.5v1c0 .276.224.5.5.5h2.559c.463 4.164 3.776 7.478 7.941 7.941V23.5c0 .276.224.5.5.5h1c.276 0 .5-.224.5-.5v-2.559c4.165-.463 7.478-3.777 7.941-7.941H23.5c.276 0 .5-.224.5-.5v-1c0-.276-.224-.5-.5-.5zM12 19c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapGeoSi);
export default __webpack_public_path__ + "static/media/map-geo-si.01968fe1.svg";
export { ForwardRef as ReactComponent };